import React from "react";
import { Link } from "react-router-dom";
import "./AttackGrid.css";

const Defenses = [
  {
    title: "SOC Monitoring",
    desc: "Aggregate logs, alerts, metrics & Dashboards.",
    emoji: "📊",
  },
  {
    title: "Firewall ACL",
    desc: "Configure ACL Rules to block malicious traffic.",
    emoji: "🔥",
  },
  {
    title: "Intrusion Detection",
    desc: "Monitor logs and network traffic to detect suspicious activity.",
    emoji: "🕵️‍♂️",
  },
  {
    title: "Endpoint Protection",
    desc: "Deploy EDR, and hardening techniques on user devices.",
    emoji: "🖥️",
  },
  // {
  //   title: "Patch Management",
  //   desc: "Keep software up to date and fix vulnerabilities proactively.",
  //   emoji: "🩹",
  // },
  // {
  //   title: "Secure Authentication",
  //   desc: "Implement MFA and strong password policies.",
  //   emoji: "🔑",
  // },
  // {
  //   title: "Backup & Recovery",
  //   desc: "Safeguard critical data and test disaster recovery procedures.",
  //   emoji: "💾",
  // },
  // {
  //   title: "Network Segmentation",
  //   desc: "Isolate network zones to limit the impact of breaches.",
  //   emoji: "🧱",
  // },
  
  // {
  //   title: "Threat Hunting",
  //   desc: "Actively search for threats in logs and system behavior.",
  //   emoji: "🔍",
  // },
  
  // {
  //   title: "Secrets Management",
  //   desc: "Store API keys, credentials, and secrets securely using vaults or key management systems.",
  //   emoji: "🗝️",
  // },
];

const aProjects= [
  {
    title: "Password Audit",
    desc: "Crack passwords given hashes.",
    emoji: "🔐",
  },
]


const attacks = [
  {
    title: "SQL Injection",
    desc: "Exploit unsanitized inputs to access or corrupt databases.",
    emoji: "🩸",
  },
  {
    title: "Hash Cracking",
    desc: "Generate & attempt to crack hashes & passwords safely.",
    emoji: "🔐",
  },
  {
    title: "WiFi Hacking",
    desc: "Capture handshake, attempt crack, deauth and evil twin.",
    emoji: " 🛜 ",
  },
  

  {
    title: "Encrypt & Decrypt",
    desc: "Understand how encryption and decryption works.",
    emoji: "🔑",
  },
  {
    title: "XSS Attack",
    desc: "Inject malicious scripts into trusted websites.",
    emoji: "🧬",
  },
  
  {
    title: "Proxy API",
    desc: "Trick users into revealing credentials via fake pages.",
    emoji: "🚨"
  },
  {
    title: "MITM",
    desc: "Intercept and manipulate data between two parties.",
    emoji: "👂"
  },

  {
    title: "Phishing",
    desc: "Trick users into revealing credentials via fake pages.",
    emoji: "🎣"
  },
  
];

function AttackGrid() {
  return (
    <>
      <section id="modules" className="grid-section1">
        <h2 className="grid-title">⚔️ Attack Simulations ↓</h2>
        <div className="attack-grid">
          {attacks.map((mod, index) => (
            <Link
              key={index}
              to={`/${mod.title.toLowerCase().replace(/\s+/g, "")}`}
              className="attack-card-link"
            >
              <div className="attack-card simple">
                <div className="emoji">{mod.emoji}</div>
                <h3>{mod.title}</h3>
                <p className="desc">{mod.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section id="modules" className="grid-section1">
        <h2 className="grid-title1">🏰 Defence Simulations ↓</h2>
        <div className="attack-grid">
          {Defenses.map((mod, index) => (
            <Link
              key={index}
              to={`/${mod.title.toLowerCase().replace(/\s+/g, "")}`}
              className="attack-card-link"
            >
              <div className="attack-card simple">
                <div className="emoji">{mod.emoji}</div>
                <h3>{mod.title}</h3>
                <p className="desc">{mod.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section id="modules" className="grid-section1">
        <h2 className="grid-title1">Attack Projects</h2>
        <div className="attack-grid">
          {aProjects.map((mod, index) => (
            <Link
              key={index}
              to={`/${mod.title.toLowerCase().replace(/\s+/g, "")}`}
              className="attack-card-link"
            >
              <div className="attack-card simple">
                <div className="emoji">{mod.emoji}</div>
                <h3>{mod.title}</h3>
                <p className="desc">{mod.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}

export default AttackGrid;
